// 超级管理员
import { Injectable } from '@angular/core';
import { API_IP } from '../../util/config';
import {StorageService} from '../../services/common/storage.service';
import * as moment from 'moment';
import {CookieService} from 'ngx-cookie-service';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProxySettingService {
  requestURL;
  public proxyName: BehaviorSubject<string> = new BehaviorSubject<string>('默认项');

  constructor(
      public http: HttpClient,
      public storageService: StorageService,
      public cookieService: CookieService
  ) { }

  // 获取可被代理的人员数据
  getProxyUsers(param) {
    this.requestURL = API_IP + '/api/proxy/users';
    return this.http.post(this.requestURL , param);
  }

  // 进入代理
  enterProxy(param) {
    this.requestURL = API_IP + '/api/proxy/enterProxy';
    return this.http.post(this.requestURL, param);
  }

  // 退出代理
  exitProxy(param) {
    this.requestURL = API_IP + '/api/proxy/exitProxy';
    return this.http.post(this.requestURL, param);
  }
}
